import { MNSproCloudApi } from '..';
import {
  GeneralPreferences,
  GeneralUserPreferenceModulePatchPayload,
  OnePropertyOf,
  UserPreferencesModules,
} from './userPreferences.interfaces';

export class GeneralPreferencesService {
  static async patchModule(
    authToken: string,
    value: GeneralUserPreferenceModulePatchPayload,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.UserPreferencesApiFactory(config);

    const rights = await api.patchModule(
      UserPreferencesModules.General,
      value.general,
    );
    return rights.data as GeneralUserPreferenceModulePatchPayload;
  }

  static async patchSettings(
    authToken: string,
    value: OnePropertyOf<GeneralPreferences>,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.UserPreferencesApiFactory(config);

    const rights = await api.patchModule(UserPreferencesModules.General, value);
    return rights.data as OnePropertyOf<GeneralPreferences>;
  }
}
